import React from 'react';
import {
	little_mail_icon,
	little_phone_icon,
	little_pin_icon,
} from '../../../utils/images';

function ClientInformations(props) {
	return (
		<div className="rdv-detail-container-open">
			<span className="title-regular">Informations du client</span>
			<div className="rdv-expert-info-details">
				<div className="group-infos">
					<span className="title-semibold">{`${props?.clientExpertRelation?.client?.firstName} ${props?.clientExpertRelation?.client?.lastName}`}</span>
					<span className="title-semibold">
						{props?.clientExpertRelation?.client?.companyName}
					</span>
				</div>
				<div className="group-infos">
					<span className="title-semibold">
						<img
							src={little_mail_icon}
							alt="little mail icon"
							className="little-mail"
						/>
						{props?.client?.user?.email || 'no mail'}
					</span>
					<span className="title-semibold">
						<img
							src={little_phone_icon}
							alt="little phone icon"
							className="little-phone"
						/>
						{props?.client?.user?.phone}
					</span>
				</div>
				<div className="group-infos group-flex-row-baseline">
					<img
						src={little_pin_icon}
						alt="little pin icon"
						className="little-pin"
					/>
					<div className="group-flex-row">
						<span className="title-semibold">{`${props?.client?.location?.zipCode} ${props?.client?.location?.city}`}</span>
					</div>
				</div>
			</div>
		</div>
	);
}

export default ClientInformations;
